import { getCertificates } from 'entities/certificates/api/getCertificate'

export const CertificatesApi = {
    getCertificates,
}
